var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"my-n2 pa-0"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"450","frameborder":"0","src":_vm.mapLink,"allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }